import React from "react";
import { Link } from "react-router-dom";
import { FaTwitter, FaDiscord, FaGithub, FaTelegram, FaEthereum } from "react-icons/fa";
import { SiBinance, SiPolygon } from "react-icons/si";


// Placeholder for your logo - replace with your actual import
const EscroniaLogo = () => (
  <div className="text-2xl font-extrabold bg-gradient-to-r from-green-400 to-blue-500 text-transparent bg-clip-text">
    ESCROWNIA
  </div>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-900 pt-16 pb-8">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          <div>
            <EscroniaLogo />
            <p className="mt-4 text-gray-400">
              The most trusted blockchain-based escrow platform for secure global transactions.
            </p>
            <div className="mt-6 flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <FaTwitter />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <FaDiscord />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <FaGithub />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <FaTelegram />
              </a>
            </div>
            </div>
          
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Product</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Features</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Smart Contracts</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Security</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">API</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Documentation</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Support</h3>
            <ul className="space-y-2">
              <li><Link to="/how-to-use" className="text-gray-400 hover:text-white transition-colors">How It Works</Link></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">FAQs</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Contact Us</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Dispute Resolution</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Fee Structure</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Legal</h3>
            <ul className="space-y-2">
              <li><Link to="/terms-of-service" className="text-gray-400 hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Cookie Policy</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">AML Policy</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">KYC Guidelines</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500">© {currentYear} Escrownia. All rights reserved.</p>
          <div className="mt-4 md:mt-0 flex flex-wrap gap-4">
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors">Supported Networks</a>
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors">Wallet Support</a>
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors">Arbitration</a>
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors">Changelog</a>
          </div>
        </div>
      </div>
      


{/* Trust badges */}
<div className="container mx-auto px-6 py-6 mt-6">
  <div className="text-center">
    <p className="text-sm text-gray-500 mb-4">Protected by Blockchain Technology</p>
    <div className="flex flex-wrap justify-center items-center gap-8">
      <div className="bg-gray-800 px-4 py-2 rounded-lg opacity-75 hover:opacity-100 transition-opacity flex items-center">
        <FaEthereum className="text-purple-400 text-3xl mr-2" />
        <span className="text-white">Ethereum</span>
      </div>
      <div className="bg-gray-800 px-4 py-2 rounded-lg opacity-75 hover:opacity-100 transition-opacity flex items-center">
        <SiBinance className="text-yellow-400 text-3xl mr-2" />
        <span className="text-white">Binance</span>
      </div>
      <div className="bg-gray-800 px-4 py-2 rounded-lg opacity-75 hover:opacity-100 transition-opacity flex items-center">
        <SiPolygon className="text-purple-500 text-3xl mr-2" />
        <span className="text-white">Polygon</span>
      </div>
      <div className="bg-gray-800 px-4 py-2 rounded-lg opacity-75 hover:opacity-100 transition-opacity flex items-center">
        <FaEthereum className="text-blue-400 text-3xl mr-2" />
        <span className="text-white">Arbitrum</span>
      </div>
    </div>
  </div>
</div>
    </footer>
          
  )
} 
export default Footer;
